import { applyFlexiLoanSagasWorker } from '../../applyFlexiLoanView/ApplyFlexiLoanView.sagas';
import { SecondCBILSDashboardSagasWorkers } from '../../CBILS/secondCBILSDashboard/SecondCBILSDashboard.sagas';
import { dashboardSagaWorkers } from '../../dashboard/Dashboard.sagas';
import { earlyRepaymentSagaWorkers } from '../../earlyRepayment/EarlyRepayment.sagas';
import { confirmFundingSagaWorkers } from '../../funding/ConfirmFundingView/ConfirmFunding.sagas';
import { fundingStepsSagaWorkers } from '../../funding/fundingSteps/FundingSteps.sagas';
import { iwocaPayDashboardSagaWorkers } from '../../iwocaPay/dashboard/Dashboard.sagas';
import { addPaymentMethodModalSagaWorkers } from '../../modals/addPaymentMethodModal/AddPaymentMethodModal.sagas';
import { editDebitCardSagaWorkers } from '../../modals/editPaymentMethodModal/EditPaymentMethodModal.sagas';
import { idCheckVerificationWorkers } from '../../modals/idCheckVerificationModal/IdCheckVerificationModal.sagas';
import { linkOpenBankingModalWorkers } from '../../modals/linkOpenBankingModal/LinkOpenBankingModal.sagas';
import { manualPaymentModalSagasWorkers } from '../../modals/manualPaymentModal/ManualPaymentModal.sagas';
import { personModalSagasWorkers } from '../../modals/personModal/PersonModal.sagas';
import { processingPaymentModalSagasWorkers } from '../../modals/processingPaymentModal/ProcessingPaymentModal.sagas';
import { repaymentScheduleSagasWorkers } from '../../modals/repaymentScheduleModal/RepaymentScheduleModal.sagas';
import { uploadDocumentsModalSagaWorkers } from '../../modals/uploadDocumentsModal/UploadDocumentsModal.sagas';
import { outstandingSaga } from '../../multiLoanDashboard/OutstandingView/OutstandingView.sagas';
import { myOffersSagaWorkers } from '../../myOffers/MyOffers.sagas';
import { profileSagaWorkers } from '../../Profile/Profile.sagas';
import { RLSDashboardSagasWorkers } from '../../RLS/dashboard/Dashboard.sagas';

export const mainContentSagaWorkers = [
    ...dashboardSagaWorkers,
    ...profileSagaWorkers,
    ...earlyRepaymentSagaWorkers,
    ...addPaymentMethodModalSagaWorkers,
    ...editDebitCardSagaWorkers,
    ...personModalSagasWorkers,
    ...linkOpenBankingModalWorkers,
    ...manualPaymentModalSagasWorkers,
    ...processingPaymentModalSagasWorkers,
    ...repaymentScheduleSagasWorkers,
    ...uploadDocumentsModalSagaWorkers,
    ...idCheckVerificationWorkers,
    ...SecondCBILSDashboardSagasWorkers,
    ...RLSDashboardSagasWorkers,
    ...iwocaPayDashboardSagaWorkers,
    ...applyFlexiLoanSagasWorker,
    ...myOffersSagaWorkers,
    ...fundingStepsSagaWorkers,
    ...confirmFundingSagaWorkers,
    ...outstandingSaga
];
